<div class="sidebar">
  <div class="header">
    <span>{{ title | translate}}</span>
    <img *ngIf="addBtn" tooltip="{{ title | translate }}" placement="bottom" (click)="addSection()"
      src="/assets/images/add-circle-outline.svg" alt="" class="add-btn">
  </div>
  <div *ngIf="sections?.length == 0">
    <img  src="/assets/images/Dynamic wizard.svg" alt="" class="empty-section-img">
  </div>
  <div *ngIf="sections?.length > 0" class="scroll-container">
    <ul class="scrollable-list">
      <li *ngFor="let section of sections; let i = index" (click)="selectSection(i)"
        [class.selected]="i === selectedIndex">
        <input class="section-block" placeholder="{{ 'add_section_name' | translate }}" type="text" [(ngModel)]="section.sectionName" (input)="onSectionNameChanged(this)">
        <img *ngIf="removeBtn" tooltip="{{ 'Remove' | translate }}" (click)="deleteSection(section, i, $event)" placement="bottom"
          src="/assets/images/remove-circle-outline.svg" alt="" class="remove-icon"
          [class.selected-remove]="i === selectedIndex">
      </li>
    </ul>
  </div>
  </div>